<template>
    <tailwind-layout title="Dashboard">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto hidden lg:flex justify-between items-center"><!-- Block for lg and larger -->
                <div class="flex flex-col">
                    <h1 class="font-semibold text-2xl leading-tight">Renter's Insurance</h1>
                    <h2 class="text-xs">Copy and share this link with your tenant to lower your risk.</h2>
                </div>
            </div>

            <div class="mb-3 px-6 lg:px-8 mx-auto flex flex-col lg:hidden"><!-- Block for sm, md, lg (buttons will stack on smaller screens) -->
                <div class="flex justify-between items-start md:items-center">
                    <div class="flex flex-col">
                        <h1 class="font-semibold text-2xl leading-tight">Renter's Insurance</h1>
                        <h2 class="text-xs">Copy and share this link with your tenant to lower your risk.</h2>
                    </div>
                </div>
            </div>
        </template>
        <div class="overflow-hidden">
            <div class="rounded-md shadow overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="overflow-hidden bg-white ring-1 ring-gray-200 p-6 flex flex-col md:flex-row justify-between gap-6">
                                <!-- Left Section -->
                                <div class="md:w-1/2 space-y-4">
                                    <h2 class="text-xl font-semibold text-gray-800">Why Require Renters Insurance?</h2>
                                    <p class="text-gray-600">
                                    Requiring tenants to purchase renters insurance ensures that your property is protected in the event of unforeseen circumstances. It provides peace of mind and reduces potential liabilities for landlords.
                                    </p>
                                    <ul class="list-disc pl-5 text-gray-600 space-y-1">
                                    <li>Protection against loss of use/relocation expenses</li>
                                    <li>Personal liability coverage</li>
                                    <li>Mitigation of property damage risks</li>
                                    <li>Keeping insurance premiums low</li>
                                    <li>Managing risks associated with pets</li>
                                    </ul>
                                    <p class="text-gray-600">
                                    We encourage you to consider adding a renters insurance requirement to your leasing agreements for enhanced property protection.
                                    </p>
                                </div>

                                <!-- Right Section -->
                                <div class="md:w-1/2 bg-gray-50 border border-gray-200 rounded-xl p-6 flex flex-col items-center text-center space-y-4">
                                    <p class="text-sm font-semibold text-gray-500 tracking-wide">POWERED BY</p>
                                    <img :src="appUrl('/sure-insurance-logo.svg')" alt="Sure Insurance Logo" class="rounded-lg bg-white ring-1 ring-gray-900/10 p-2 w-20">
                                    
                                    <p class="text-gray-600">
                                    Need to request renters insurance? We've partnered with Sure to offer renters insurance. Send this link to your tenants to help them get started:
                                    </p>
                                    
                                    <div class="w-full">
                                    <input type="text" id="insurance-link" :value="sure_insurance_url" readonly class="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-gray-100 focus:outline-none">
                                    </div>
                                    
                                    <button
                                        @click="copyToClipboard"
                                        class="primaryButton"
                                    >
                                        <!-- eslint-disable-next-line vue/no-undef-properties -->
                                        {{ isLinkCopied ? 'Link Copied!' : 'Copy Link' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import Button from "@/Jetstream/Button.vue";

export default {
    components: {
        Button,
        TailwindLayout
    },
    props: {
        sure_insurance_url: String
    },
    data() {
        return {
        }
    },
    watch: {

    },
    methods: {
        async copyToClipboard() {
            try {
                await navigator.clipboard.writeText(this.sure_insurance_url);
                alert('Copied');
            } catch($e) {
                alert('Cannot copy');
            }
        },
    },
}
</script>
